/* Per-client build tracking dashboard — opened from the grey "x builds shipped
   this past week" affordance on a client card. Reads window.MAV.clientBuildStats
   + jobs. Portal modal, reuses fb-overlay/fb-modal shell. */

const { useState: useCsState } = React;
const CS_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

function ClientBuildsModal({ slug, onClose }) {
  const MAV = window.MAV;
  const c = MAV.clientBySlug(slug);
  if (!c) return null;
  const st = MAV.clientBuildStats(slug);
  if (st.unavailable) return ReactDOM.createPortal(
    <div className="fb-overlay" onClick={onClose}>
      <div className="fb-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 540 }}>
        <div className="fb-head">
          <h2 className="fb-title">{c.name} · build tracking</h2>
          <button className="icon-act" onClick={onClose} title="Close"><I.x size={16} /></button>
        </div>
        <div className="fb-body">Build history not available yet</div>
      </div>
    </div>,
    document.body
  );
  const max = Math.max(...st.trend, 1);
  const team = MAV.pods.find(p => (p.clientSlugs || []).includes(slug));
  // recent shipped builds for this client, newest first
  const recent = MAV.jobs.filter(j => j.client === slug);

  return ReactDOM.createPortal(
    <div className="fb-overlay" onClick={onClose}>
      <div className="fb-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 540 }}>
        <div className="fb-head">
          <div>
            <div className="row gap-8" style={{ marginBottom: 8 }}>
              <ClientBadge slug={slug} size={30} />
              <span className="chip mono" style={{ fontSize: 11 }}>{c.slug}</span>
              {team && <span className="chip" style={{ fontSize: 10.5 }}><I.users size={10} /> {team.name}</span>}
            </div>
            <h2 className="fb-title">{c.name} · build tracking</h2>
            <p className="fb-sub">Shipped-build volume logged for this client.</p>
          </div>
          <button className="icon-act" onClick={onClose} title="Close"><I.x size={16} /></button>
        </div>

        <div className="fb-body">
          {/* headline numbers */}
          <div className="cs-stat-row">
            <div className="cs-stat"><div className="cs-stat-v">{st.week}</div><div className="cs-stat-k">This week</div></div>
            <div className="cs-stat"><div className="cs-stat-v">{st.month}</div><div className="cs-stat-k">This month</div></div>
            <div className="cs-stat"><div className="cs-stat-v">{st.total.toLocaleString()}</div><div className="cs-stat-k">All-time</div></div>
          </div>

          {/* 7-day trend */}
          <div className="cs-section">
            <div className="row between" style={{ marginBottom: 12 }}>
              <span className="cs-sec-title">Past 7 days</span>
              <span className="muted" style={{ fontSize: 11 }}>{st.week} shipped</span>
            </div>
            <div className="cs-spark">
              {st.trend.map((v, i) => (
                <div key={i} className="cs-bar-col" title={CS_DAYS[i] + ': ' + v + (v === 1 ? ' build' : ' builds')}>
                  <div className="cs-bar-track">
                    <div className="cs-bar-fill" style={{ height: (v / max * 100) + '%', opacity: v ? 1 : 0.18 }}></div>
                  </div>
                  <span className="cs-bar-v">{v}</span>
                  <span className="cs-bar-d">{CS_DAYS[i][0]}</span>
                </div>
              ))}
            </div>
          </div>

          {/* recent builds for this client */}
          <div className="cs-section">
            <span className="cs-sec-title">Recent builds</span>
            <div className="col gap-8" style={{ marginTop: 10 }}>
              {recent.length ? recent.map(j => (
                <div key={j.id} className="cs-build">
                  <span className="ai" style={{ width: 28, height: 28 }}><I.doc size={13} /></span>
                  <div className="grow" style={{ minWidth: 0 }}>
                    <div className="mono" style={{ fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{j.name}</div>
                    <div className="muted" style={{ fontSize: 11 }}>{j.id} · {j.started}</div>
                  </div>
                  <StatusPill status={j.status} verdict={j.verdict} />
                </div>
              )) : <p className="muted" style={{ fontSize: 12.5, margin: 0 }}>No builds in the current run log for {c.name}.</p>}
            </div>
          </div>

          <p className="muted" style={{ fontSize: 11, margin: '4px 0 0', lineHeight: 1.5 }}>
            <I.coins size={11} style={{ verticalAlign: '-1px', marginRight: 3 }} />Volume is also included per-client in the Admin desk CSV export.
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
}

window.ClientBuildsModal = ClientBuildsModal;
